import React from 'react';
import { FaTimes } from 'react-icons/fa';
import {
  ModalOverlay,
  ApplicationsContainer,
  ModalHeader,
  ModalTitle,
  CloseButton,
  ApplicationsList,
  ApplicationCard,
  ApplicationCardContent,
  ApplicationDetails,
  ApplicationStatusSection,
  ApplicationStatusBadge,
  ApplicationActions,
  ActionLink,
  StatusSelect,
  NoApplicationsMessage
} from '../../../../styles/components/JobPostManagement';

const ApplicationsView = ({ 
  jobPost, 
  applications, 
  onClose,
  getStatusDisplay
}) => {
  return (
    <ModalOverlay>
      <ApplicationsContainer>
        <ModalHeader>
          <ModalTitle>Applications for {jobPost.title}</ModalTitle>
          <CloseButton onClick={onClose}>
            <FaTimes />
          </CloseButton>
        </ModalHeader>
        
        {applications.length === 0 ? (
          <NoApplicationsMessage>
            <h3>No Applications Yet</h3>
            <p>This job post hasn't received any applications yet. Check back later.</p>
          </NoApplicationsMessage>
        ) : (
          <ApplicationsList>
            {applications.map((application) => {
              const statusInfo = getStatusDisplay(application.status);
              return (
                <ApplicationCard key={application.id}>
                  <ApplicationCardContent>
                    <ApplicationDetails>
                      <h3>{application.studentName}</h3>
                      <div style={{ marginBottom: '0.5rem' }}>
                        <p><strong>University:</strong> {application.studentUniversity}</p>
                        <p><strong>Major:</strong> {application.studentMajor}</p>
                        <p><strong>GPA:</strong> {application.studentGPA}</p>
                        <p><strong>Applied On:</strong> {application.appliedDate}</p>
                        {(application.status === 'current intern' || application.status === 'internship complete') && (
                          <>
                            <p><strong>Start Date:</strong> {application.startDate}</p>
                            <p><strong>End Date:</strong> {application.endDate}</p>
                          </>
                        )}
                      </div>
                      <div style={{ marginBottom: '0.5rem' }}>
                        <strong>Skills:</strong>{' '}
                        {application.studentSkills.map((skill, index) => (
                          <span 
                            key={index}
                            style={{
                              display: 'inline-block',
                              background: 'rgba(99, 102, 241, 0.15)',
                              color: 'rgba(255, 255, 255, 0.9)',
                              padding: '0.25rem 0.5rem',
                              borderRadius: '4px',
                              fontSize: '0.75rem',
                              border: '1px solid rgba(99, 102, 241, 0.3)',
                              margin: '0 0.25rem 0.25rem 0'
                            }}
                          >
                            {skill}
                          </span>
                        ))}
                      </div>
                      <div style={{ marginBottom: '0.5rem' }}>
                        <p><strong>Email:</strong> {application.studentEmail}</p>
                        <p><strong>Phone:</strong> {application.studentPhone}</p>
                      </div>
                      <ApplicationActions>
                        <ActionLink href={application.resumeUrl} target="_blank">View Resume</ActionLink>
                        <ActionLink href={application.coverLetterUrl} target="_blank">View Cover Letter</ActionLink>
                      </ApplicationActions>
                    </ApplicationDetails>
                    
                    <ApplicationStatusSection>
                      <ApplicationStatusBadge 
                        bgColor={statusInfo.color}
                        textColor={statusInfo.textColor || 'white'}
                      >
                        {statusInfo.text}
                      </ApplicationStatusBadge>
                      
                      <StatusSelect
                        value={application.status}
                        onChange={(e) => {
                          // In a real app, this would update the status
                          console.log(`Changing status for ${application.studentName} to ${e.target.value}`);
                        }}
                      >
                        <option value="pending">Pending</option>
                        <option value="reviewing">Reviewing</option>
                        <option value="interview">Interview</option>
                        <option value="accepted">Accepted</option>
                        <option value="rejected">Rejected</option>
                        <option value="current intern">Current Intern</option>
                        <option value="internship complete">Internship Complete</option>
                      </StatusSelect>
                    </ApplicationStatusSection>
                  </ApplicationCardContent>
                </ApplicationCard>
              );
            })}
          </ApplicationsList>
        )}
      </ApplicationsContainer>
    </ModalOverlay>
  );
};

export default ApplicationsView;
